import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from "@/views/auth/LoginPage";
import RegistrationPage from "@/views/auth/RegistrationPage";
import RedirectPage from "@/views/auth/RedirectPage";

import HomePage from "@/views/HomePage";
import AccountIndex from "@/views/account/IndexPage";

import LibraryListPage from "@/views/library/ListPage";
import LibraryIndexPage from "@/views/library/IndexPage";

import MessageIndexPage from "@/views/message/IndexPage";

import SessionListPage from "@/views/session/ListPage";
import SessionIndexPage from "@/views/session/IndexPage";

import FormListPage from "@/views/session/form/ListPage";
import FormIndexPage from "@/views/session/form/IndexPage";

import InstructionListPage from "@/views/session/instruction/ListPage";
import InstructionIndexPage from "@/views/session/instruction/IndexPage";

import ExerciseListPage from "@/views/session/exercise/ListPage";
import ExerciseIndexPage from "@/views/session/exercise/IndexPage";

import SurveyListPage from "@/views/session/survey/ListPage";
import SurveyIndexPage from "@/views/session/survey/IndexPage";

import QuizIndexPage from "@/views/session/quiz/IndexPage";

import FileListPage from "@/views/session/file/ListPage";
import FileIndexPage from "@/views/session/file/IndexPage";

import AccountNamePage from "@/views/account/profile/NamePage";
import AccountTimezonePage from "@/views/account/profile/TimezonePage";
import AccountEmailPage from "@/views/account/profile/EmailPage";
import AccountPasswordPage from "@/views/account/profile/PasswordPage";

import SettingListPage from "@/views/account/setting/ListPage";

import NotificationListPage from "@/views/account/notification/ListPage";
import NotificationIndexPage from "@/views/account/notification/IndexPage";

import ConnectListPage from "@/views/account/connect/ListPage";
import ConnectIndexPage from "@/views/account/connect/IndexPage";

import AdvocateListPage from "@/views/account/advocate/ListPage";
import AdvocateIndexPage from "@/views/account/advocate/IndexPage";
import AdvocateReportPage from "@/views/account/advocate/ReportPage";

import GoalListPage from "@/views/account/goal/ListPage";
import GoalIndexPage from "@/views/account/goal/IndexPage";

import PoapListPage from "@/views/account/poap/ListPage";
import PoapIndexPage from "@/views/account/poap/IndexPage";

import ProductListPage from "@/views/product/ListPage";
import ProductIndexPage from "@/views/product/IndexPage";

import ReportListPage from "@/views/account/report/ListPage";

import OrderIndexPage from "@/views/order/IndexPage";
import OrderListPage from "@/views/order/ListPage";



const routes = [
    {
        path: '/redirect/:token',
        name: 'redirect',
        component: RedirectPage,
        meta: { auth: false,  title: 'Redirect', 'showBackBar': false, 'showBottomBar': false}
    },
    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        meta: { auth: false,  title: 'Login', 'showBackBar': false, 'showBottomBar': false}
    },
    {
        path: '/register',
        name: 'registration',
        component: RegistrationPage,
        meta: { auth: false,  title: 'Registration', 'showBackBar': false, 'showBottomBar': false}
    },
    {
        path: '/library',
        name: 'libraryList',
        component: LibraryListPage,
        meta: { auth: true,  title: 'Library', 'showBackBar': false, 'showBottomBar': true}
    },
    {
        path: '/product',
        name: 'productList',
        component: ProductListPage,
        meta: { auth: true,  title: 'Product List', 'showBackBar': false, 'showBottomBar': true}
    },
    {
        path: '/product/:id',
        name: 'productIndex',
        component: ProductIndexPage,
        meta: { auth: true,  title: 'Product Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/order/list/:status',
        name: 'order',
        component: OrderListPage,
        meta: { auth: true,  title: 'Order List', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/order/:id',
        name: 'orderIndex',
        component: OrderIndexPage,
        meta: { auth: true,  title: 'Order Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/library/:id',
        name: 'libraryIndex',
        component: LibraryIndexPage,
        meta: { auth: true,  title: 'Library Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/message',
        name: 'message',
        component: MessageIndexPage,
        meta: { auth: true,  title: 'Message', 'showBackBar': false, 'showBottomBar': true}
    },
    {
        path: '/account',
        name: 'account',
        component: AccountIndex,
        meta: { auth: true,  title: 'Account', 'showBackBar': false, 'showBottomBar': true}
    },
    {
        path: '/account/name',
        name: 'accountName',
        component: AccountNamePage,
        meta: { auth: true,  title: 'Account Name', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/account/timezone',
        name: 'accountTimezone',
        component: AccountTimezonePage,
        meta: { auth: true,  title: 'Account Timezone', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/account/email',
        name: 'accountEmail',
        component: AccountEmailPage,
        meta: { auth: true,  title: 'Account Email', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/account/password',
        name: 'accountPassword',
        component: AccountPasswordPage,
        meta: { auth: true,  title: 'Account Password', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: { auth: true,  title: 'Today\'s Session', 'showBackBar': false, 'showBottomBar': true}
    },
    {
        path: '/session/list',
        name: 'sessionList',
        component: SessionListPage,
        meta: { auth: true,  title: 'My Sessions', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/exercise/list',
        name: 'exerciseList',
        component: ExerciseListPage,
        meta: { auth: true,  title: 'My Exercises', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/exercise/:id',
        name: 'exerciseIndex',
        component: ExerciseIndexPage,
        meta: { auth: true,  title: 'Exercise Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/session/:id',
        name: 'sessionIndex',
        component: SessionIndexPage,
        meta: { auth: true,  title: 'Session Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/form/list',
        name: 'formList',
        component: FormListPage,
        meta: { auth: true,  title: 'My Forms', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/file/:id',
        name: 'fileIndex',
        component: FileIndexPage,
        meta: { auth: true,  title: 'File Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/instruction/list',
        name: 'instructionList',
        component: InstructionListPage ,
        meta: { auth: true,  title: 'My Instructions', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/instruction/:id',
        name: 'instructionIndex',
        component: InstructionIndexPage,
        meta: { auth: true,  title: 'Instruction Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/survey/list',
        name: 'surveyList',
        component: SurveyListPage ,
        meta: { auth: true,  title: 'My Surveys', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/survey/:id',
        name: 'surveyIndex',
        component: SurveyIndexPage,
        meta: { auth: true,  title: 'Survey Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/quiz/:id',
        name: 'quizIndex',
        component: QuizIndexPage,
        meta: { auth: true,  title: 'Quiz Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/file/list',
        name: 'fileList',
        component: FileListPage ,
        meta: { auth: true,  title: 'My Files', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/form/:id',
        name: 'formIndex',
        component: FormIndexPage,
        meta: { auth: true,  title: 'Form Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/notification/list',
        name: 'notificationList',
        component: NotificationListPage,
        meta: { auth: true,  title: 'My Notifications', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/notification/:id',
        name: 'notificationIndex',
        component: NotificationIndexPage,
        meta: { auth: true,  title: 'Notification Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/setting/list',
        name: 'settingList',
        component: SettingListPage,
        meta: { auth: true,  title: 'My Setting', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/connect/list',
        name: 'connectList',
        component: ConnectListPage ,
        meta: { auth: true,  title: 'My Connects', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/connect/:id',
        name: 'connectIndex',
        component: ConnectIndexPage,
        meta: { auth: true,  title: 'Connect Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/advocate/list',
        name: 'advocateList',
        component: AdvocateListPage ,
        meta: { auth: true,  title: 'My Advocates', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/advocate/:id',
        name: 'advocateIndex',
        component: AdvocateIndexPage,
        meta: { auth: true,  title: 'Advocate Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/advocate/report/:id',
        name: 'advocateReport',
        component: AdvocateReportPage,
        meta: { auth: true,  title: 'Advocate Report', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/goal/list',
        name: 'goalList',
        component: GoalListPage ,
        meta: { auth: true,  title: 'My Goals', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/goal/:id',
        name: 'goalIndex',
        component: GoalIndexPage,
        meta: { auth: true,  title: 'Goal Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/poap/list',
        name: 'poapList',
        component: PoapListPage ,
        meta: { auth: true,  title: 'My POAPs', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/poap/:id',
        name: 'poapIndex',
        component: PoapIndexPage,
        meta: { auth: true,  title: 'POAP Detail', 'showBackBar': true, 'showBottomBar': false}
    },
    {
        path: '/report/list',
        name: 'reportList',
        component: ReportListPage ,
        meta: { auth: true,  title: 'My Reports', 'showBackBar': true, 'showBottomBar': false}
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})


router.beforeEach((to, from, next) => {
    const user = JSON.parse(localStorage.getItem('user'));
    let isAuthenticated = false;
    if (user != null && user.access_token != null) {
        isAuthenticated = true;
    }
    if (to.matched.some(record => record.meta.auth) && !isAuthenticated) {
        next('/login');
    } else {
        next();
    }
})

export default router
